<template lang="pug">
  y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-4
        div.h6.basic800--text {{ selectedShippingType === 'courier' ? $t('edit_shipping_option') : $t('edit_delivery_option') }}
        v-spacer
        v-btn(text icon small @click="closeDialog")
          eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
      v-card-text.px-4
        div.s1.danger500--text(v-if="!lead.yezzashipping.fulfilment") {{ $t('selected_courier_unavailable') }}
        div.s1.danger500--text(v-if="!lead.yezzashipping.weight") {{ $t('product_weight_missing') }}
        div.p2.primary500--text.mt-2 {{ $t('choose_one_of_options') }}:
        div.mt-4(style="border:1px solid var(--v-basic400); border-radius: 4px;")
          template(v-if="!lead.yezzashipping.weight")
            div.pa-4.d-flex.align-center(@click="editWeightDialog = true")
              div.s2.primary--text {{ $t('edit_weight') }}
              v-spacer
              eva-icon.mb-n2(name="chevron-right" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
            v-divider.basic400
          template(v-if="!lead.yezzashipping.fulfilment")
            div.pa-4.d-flex.align-center(@click="editShippingDialog = true")
              div.s2.primary--text {{ selectedShippingType === 'courier' ? $t('select_different_courier') : $t('select_different_delivery') }}
              v-spacer
              eva-icon.mb-n2(name="chevron-right" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
            v-divider.basic400
          div.pa-4.d-flex.align-center(@click="selectedShippingType === 'courier' ? editDateDialog = true : editDateTimeDialog = true")
            div.s2.primary--text {{ selectedShippingType === 'courier' ? $t('change_shipping_date') : $t('change_delivery_date_time') }} 
            v-spacer
            eva-icon.mb-n2(name="chevron-right" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
          v-divider.basic400
          div.pa-4.d-flex.align-center(v-if="lead.postcode_error || lead.area_error" @click="editRecipientPostcodeDialog = true")
            div.s2.primary--text {{ $t('update_recipient_address') }}
            v-spacer
            eva-icon.mb-n2(name="chevron-right" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
          v-divider.basic400
          div.pa-4.d-flex.align-center(@click="openRemoveOrderDialog = true")
            div.s2.danger500--text {{ $t('remove_this_order_now') }}
            v-spacer
            eva-icon.mb-n1(name="trash-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="18" height="18")

      .modal
        edit-weight(v-if="editWeightDialog" :open.sync="editWeightDialog" :parentYezzaShipping.sync="yezzaShipping" @updateWeight="editShippingDialog = true")
        edit-shipping(v-if="editShippingDialog" :open.sync="editShippingDialog" :selectedShippingType="selectedShippingType" :lead="lead" :parentSelectedFulfilment.sync="selectedFulfilment" :parentYezzaShipping.sync="yezzaShipping")
        edit-date-time(v-if="editDateTimeDialog" :open.sync="editDateTimeDialog" :parentYezzaShipping.sync="yezzaShipping")
        edit-date(v-if="editDateDialog" :open.sync="editDateDialog" :parentYezzaShipping.sync="yezzaShipping")
        edit-postcode(v-if="editRecipientPostcodeDialog" :open.sync="editRecipientPostcodeDialog" :parentYezzaShipping.sync="yezzaShipping" :lead="lead" @updated="$emit('updated')")
        y-dialog(v-if="openRemoveOrderDialog" v-model='openRemoveOrderDialog', max-width='320')
          v-card
            v-card-title.h6.basic800--text.px-4 {{ $t('remove_this_order') }}
            v-card-text.p2.primary500--text.px-4 {{ $t('remove_this_order_desc') }}
            v-card-actions
              v-spacer
              v-btn(color='white', text @click='openRemoveOrderDialog = false')
                .button-Aa-small.primary400--text {{ $t('cancel') }}
              v-btn.mr-2(color='danger500' depressed height=32 @click='removeOrder')
                .button-AA-small.basic100--text {{ $t('confirm') }}

</template>

<script>
import { mapActions } from 'vuex'
import EditWeight from '@/components/dialogs/yezzashipping/EditWeight.vue'
import EditShipping from '@/components/dialogs/yezzashipping/EditShipping.vue'
import EditDateTime from '@/components/dialogs/yezzashipping/EditDateTime.vue'
import EditDate from '@/components/dialogs/yezzashipping/EditDate.vue'
import EditPostcode from '@/components/dialogs/yezzashipping/EditPostcode.vue'

export default {
  name: 'EditErrorOrder',
  props: ['open', 'parentYezzaShipping', 'selectedShippingType', 'lead'],
  components: { EditWeight, EditShipping, EditDateTime, EditDate, EditPostcode },
  data: () => ({
    isLoading: false,
    editWeightDialog: false,
    editShippingDialog: false,
    editDateTimeDialog: false,
    editDateDialog: false,
    editRecipientPostcodeDialog: false,
    openRemoveOrderDialog: false,
    selectedFulfilment: null
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    yezzaShipping: {
      get () {
        return this.parentYezzaShipping
      },
      set (newValue) {
        this.$emit('update:parentYezzaShipping', newValue)
      }
    }
  },
  mounted () {
    this.selectedFulfilment = this.yezzaShipping.fulfilment
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    removeOrder () {
      this.$emit('remove', this.yezzaShipping)
      this.showModal = false
    },
    closeDialog () {
      this.showModal = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "choose_one_of_options": "Choose one of the options below",
    "update_recipient_address": "Update Recipient Address",
    "remove_this_order_now": "Remove this order for now",
    "remove_this_order": "Remove this order?",
    "remove_this_order_desc": "Your selections for this order will not be saved.",
    "select_different_courier": "Select a different courier",
    "select_different_delivery": "Select a different delivery",
    "edit_shipping_option": "Edit shipping option",
    "edit_delivery_option": "Edit delivery option",
    "change_shipping_date": "Change shipping date",
    "change_delivery_date_time": "Change delivery date and time"
  },
  "id": {
    "choose_one_of_options": "Pilih salah satu opsi di bawah",
    "update_recipient_address": "Perbarui Alamat Penerima",
    "remove_this_order_now": "Hapus pesanan ini untuk sekarang",
    "remove_this_order": "Hapus pesanan ini?",
    "remove_this_order_desc": "Pilihan kamu untuk pesanan ini tidak akan disimpan.",
    "select_different_courier": "Pilih kurir lain",
    "select_different_delivery": "Pilih pengiriman lain",
    "edit_shipping_option": "Edit opsi pengiriman",
    "edit_delivery_option": "Edit opsi pengiriman",
    "change_shipping_date": "Ubah tanggal pengiriman",
    "change_delivery_date_time": "Ubah tanggal dan waktu pengiriman"
  }
}
</i18n>